import { createContext, useContext } from 'react';

/**
 * Per-card context provided by the flat `sidebar-cards-admin-management`
 * renderer around each rendered card. It lets the shared `VisibilityToggle` —
 * which is embedded inside the individual card components — source its
 * visibility state from the flat model without having to rewire every card's
 * JSX.
 */
export type FlatCardContextValue = {
  /**
   * Hidden by the org default or the agent's own choice, ignoring conditions —
   * what the visibility toggle's icon reflects.
   */
  readonly isUserHidden: boolean;
  /** Hidden because its conditions didn't match — surfaced as a tooltip. */
  readonly isConditionHidden: boolean;
  readonly toggleVisibility: () => void;
};

export const FlatCardContext = createContext<FlatCardContextValue | null>(null);

export const useFlatCardContext = (): FlatCardContextValue | null =>
  useContext(FlatCardContext);
